const moduleName = 'engagementModalBehavior'

const triggerActions = [
  'tabList/saveCard',
  'tabList/unsaveCard',
  'tabList/ignoreCard',
  'tabList/unignoreCard',
  'requirements/applyRequirement',
  'requirements/deleteRequirement',
  'details/apply'
]

export const initSubscribers = (context) => {
  context.store.subscribeAction({
    before: ({ type }) => {
      if (!triggerActions.includes(type)) { return }
      context.store.commit(`${moduleName}/setState`, { stateName: 'isEngaged', data: true })
    },
    after: ({ type, payload }) => {
      if (type === 'account/loginAccount') {
        context.store.dispatch(`${moduleName}/changeSessionAppearingCondition`, true)
      }
      if (type === 'engagementModal/postOption') {
        const { scholarshipId, optionId, details } = payload
        const option = context.store.state.engagementModal.options.find(opt => opt.id === optionId)
        const props = { [context.$mixpanel.props.NO_ENGAGEMENT_REASON]: option.title }

        if (details) {
          props[context.$mixpanel.props.NO_ENGAGEMENT_REASON_TEXT] = details
        }

        context.$mixpanel.track(
          context.$mixpanel.events.NO_ENGAGEMENT_SURVEY_BTN_CLICK,
          context.$mixpanel.fillProps(
            context.$mixpanel.events.NO_ENGAGEMENT_SURVEY_BTN_CLICK,
            { scholarshipId: Number(scholarshipId), props }
          )
        )
      }
    }
  })
}
